module.exports = __webpack_public_path__ + "fonts/FetteUNZFraktur.0a8db2c8.woff";